module.exports = __webpack_public_path__ + "static/media/au-coeur-de-l-actualite-des-consomacteurs-le-bio-mini.99b75b6a.jpg";